import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import { getCurrentLanguage } from './assets/js/functions';
import App from './views/App';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Router basename={`/maestros/${getCurrentLanguage()}`}>
    <App />
  </Router>,
);
